import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { API_URL } from '@frontend/basic';
import { catchError, of } from 'rxjs';
import { ParameterService, PaymentService } from '@frontend/frontendlib';

@Component({
  selector: 'app-ready',
  templateUrl: './ready.component.html',
  styleUrls: ['./ready.component.css'],
})
export class ReadyComponent implements OnInit {
  final_text = computed(
    () =>
      this.parameterService.channel?.success_message ??
      'Wir haben Ihr Geld erhalten.'
  );
  loading = signal(false);
  error = signal(false);

  private basicApiUrl = inject(API_URL);
  private paymentService = inject(PaymentService);
  private parameterService = inject(ParameterService);
  public choosedPaymentprovider = this.parameterService.choosedPaymentprovider;
  public backUrl = computed(() => `?channel=${this.parameterService.queryParams.channel_id}&payment=${this.parameterService.queryParams.payment_id}`);
  public hasDownload = computed(() => this.parameterService.download);
  public downloadUrl = computed(() => `${this.basicApiUrl}/v1/publicpay/${this.parameterService.queryParams.channel_id}/payment/${this.parameterService.queryParams.payment_id}/download`);

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    if (
      (this.parameterService.queryParams.seccode !== undefined) ||
      (this.parameterService.queryParams.amazonCheckoutSessionId !== undefined)
    ) {
      this.loading.set(true);
      this.paymentService
        .capture(
          this.parameterService.queryParams.channel_id,
          this.parameterService.queryParams.payment_id ?? '',
          this.parameterService.getAllQueryParameter()
        ).pipe(
          catchError(() => {
            return of({
              success: false,
            });
          })
        )
        .subscribe((val) => {
          if (val.success === true) {
            this.parameterService.runGoogleTag('purchase');
          } else {
            this.error.set(true);
          }
          this.loading.set(false);
        });
    }
    else {
      if ((this.parameterService.payment?.state ?? 0) === 2)
      {
        this.loading.set(false);
      }
      else {
        this.error.set(true);
      }
    }
  }

  get imgUrl() {
    return this.parameterService.imgUrl;
  }
}
